import { Routes } from '@angular/router';
import { authenticatedGuard } from '@guards/authenticated.guard';

export const developersRoutes: Routes = [
  {
    canActivate: [authenticatedGuard],
    data: { key: 'developers' },
    loadComponent: () => import('./developers/developers.page').then((m) => m.DevelopersPage),
    path: '',
    title: 'Dashboard Desarrolladores | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'new-developer' },
    loadComponent: () => import('./developer-form/developer-form.page').then((m) => m.DeveloperFormPage),
    path: 'new',
    title: 'Crear Desarrollador | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'developer-details' },
    loadComponent: () => import('./developer-details/developer-details.page').then((m) => m.DeveloperDetailsPage),
    path: ':developerId',
    title: 'Dashboard Detalles del desarrollador | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'edit-developer' },
    loadComponent: () => import('./developer-form/developer-form.page').then((m) => m.DeveloperFormPage),
    path: ':developerId/edit',
    title: 'Editar Desarrollador | Mundo Hogar',
  },
];
